import { useState, useEffect, useRef } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop } from '../../../utils/Utils';
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';
import { useHistory } from "react-router-dom";
import { PlannerApi } from '../../../api/PlannerApi';
import Loader from '../../../custom_views/Loader';
import { getCookie } from '../../../utils/CookieHelper';
import autosize from 'autosize';

function DeclinePlannerDialog(props) {
    const [isDeclineLoading, setDeclineLoading] = useState(false)
    const refTextarea = useRef(null)
    useEffect(() => {
        if (props.isShow){
            //refTextarea.current.focus();
            autosize(refTextarea.current);
        }
    }, [props.isShow])
    const [text, setText] = useState("")
    const planner = props.msg.planner != undefined ? props.msg.planner : {}
    const cancel = () => {
        setShow()
    }
    const decline = () => {
        setDeclineLoading(true)
        const params = {
            "planner_ids": planner._id,
            "other_vk_caller_id": planner.client_vk_caller_id == getCookie("id") ? planner.repetitor_vk_caller_id : planner.client_vk_caller_id,
            "reason" : text
        }
        PlannerApi.cancelPlanner(params, (responseData) => {
            setDeclineLoading(false)
            setShow()
            props.plannerMsgChanged(planner._id, false)

            var newMsg = {...props.msg}
            newMsg.planner.accepted = false
            props.changeMsg(newMsg)
        }, (responseData) => {
            setDeclineLoading(false)
        })
    }
    const setShow = () => {
        props.setDeclinePlanner({isShow : false, msg :{}})
    }
    const isDesktop = getIsDesktop()
    const getInnerHtml = () => {
        return(
            <div style={{textAlign : 'left'}} className="rules_container">
                <div className="chat_decline_planner_title">Вы собираетесь отклонить приглашение</div>
                <div className="chat_decline_planner_desc">Причина (это поле обязательное)</div>
                <textarea ref={refTextarea} style={{minHeight : '24px'}} placeholder="Например, не могу в это время" className="profile_input profile_textare_bio"  value={text} onChange={(e) => setText(e.target.value)}/>

                {/* <input onChange={(e) => setText(e.target.value)} className="chat_decline_planner_input" placeholder="Например, не могу в это время" type="text" value={text}/> */}
                <div className="chat_decline_planner_line"/>
                {/* <div className="chat_decline_planner_desc">100/400 символов</div> */}
                <div style={{justifyContent : 'space-between', marginTop : '68px'}} className="rules_btns">
                    <div style={{maxHeight : '48px'}} onClick={cancel} className="rules_left_btn hover">Отмена</div>
                    <div style={text.length > 0 ? {maxHeight : '48px'} : {pointerEvents : 'none', opacity : '0.3', maxHeight : '48px'}} onClick={decline} className="rules_left_btn rules_right_btn hover relative">{isDeclineLoading ? <Loader/> : "Подтвердить"}</div>
                </div>
            </div>
        )
    }
    if (isDesktop){
        if (!props.isShow){
            return(<div/>)
        } 
        return(<BaseDesktopDialog isShow={props.isShow} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} open={props.isShow}>
               {getInnerHtml()}
            </BottomSheet>
        )
    }
}

export default DeclinePlannerDialog;
